import component from './HashAvatar'

export default component
